import Loading from '../../../../Dashboards/Common/Loading';
import { FamiliesPerEstablishmentSocialHealth } from './FamiliesPerEstablishmentHealthAssistance';
import { FamiliesPerEstablishmentSocialAssistance } from './FamiliesPerEstablishmentSocialAssistance';
import { FamiliesPerLocality } from './FamiliesPerLocality';
import { useCollectionMethodChartsDataContext } from './hooks/useCollectionMethodChartsDataContext';

export const Charts = () => {
    const { isLoading } = useCollectionMethodChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards" >
                <FamiliesPerEstablishmentSocialAssistance/>
                <FamiliesPerEstablishmentSocialHealth/>
            </div>
            <div className="charts-row-dashboards">
                <FamiliesPerLocality/>
            </div>
        </>
    );
};
